<div class="lancamentos-header">
  <h2 class="accent-color lancamentos-text">Lançamentos</h2>
  <div class="inline-element lancamentos-acoes">
    <p-floatLabel variant="on">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
        <input
          pInputText
          id="buscarLancamento"
          (input)="dtLancamentos.filterGlobal($any($event.target).value, 'contains')" />
        </p-iconField>
        <label for="buscarLancamento">Buscar</label>
      </p-floatLabel>
      <mat-divider *hasPermission="permissaoEditarLancamento" [vertical]="true" class="vertical-mat-divider"></mat-divider>

      <!-- Modo normal: botão para ativar seleção em massa -->
      @if (!modoSelecao) {
        <button *hasPermission="permissaoEditarLancamento" pButton icon="pi pi-check-square" text rounded severity="secondary"
          matTooltip="Editar lançamentos em massa" (click)="ativarModoSelecao()">
        </button>
      }

      <!-- Modo seleção em massa: toolbar de ações -->
      @if (modoSelecao) {
        <span class="selecao-toolbar">
          <span class="selecao-contador">{{ lancamentosSelecionados.length }} selecionado(s)</span>
          <button pButton icon="pi pi-tag" label="Alterar Tipo" text rounded severity="secondary"
            (click)="alterarTipoEmMassaClick()">
          </button>
          <button pButton icon="pi pi-calendar" label="Alterar Data" text rounded severity="secondary"
            (click)="alterarDataEmMassaClick()">
          </button>
          <button pButton icon="pi pi-times" text rounded severity="secondary"
            matTooltip="Cancelar seleção" (click)="cancelarModoSelecao()">
          </button>
        </span>
      }

      <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>
      <button mat-stroked-button (click)="exportarExcel()" [disabled]="exportandoExcel">
        <mat-icon>download</mat-icon>
        {{ exportandoExcel ? 'Exportando...' : 'Exportar Excel' }}
      </button>
    </div>
  </div>

  <div class="table-container">
    <p-table #dtLancamentos [value]="resultado.lancamentos" [paginator]="true" [rows]="10"
      [rowsPerPageOptions]="[10, 25, 50, 100]" responsiveLayout="scroll" editMode="row" dataKey="id"
      [globalFilterFields]="['nomeConta', 'tipoLancamento.nome', 'nomeLoteLancamentos', 'observacao', 'dataFormatada', 'valor', 'nomeCategoria', 'observacaoCategoria']"
      [selectionMode]="modoSelecao ? 'multiple' : undefined"
      [(selection)]="lancamentosSelecionados"
      [rowSelectable]="isLancamentoSelecionavel"
      sortMode="multiple">

      <ng-template pTemplate="header">
        <tr>
          @if (modoSelecao) {
            <th class="col-checkbox">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
          }
          <th pSortableColumn="data">Data <p-sortIcon field="data" /></th>
          <th pSortableColumn="valor">Valor <p-sortIcon field="valor" /></th>
          <th pSortableColumn="nomeConta">Conta <p-sortIcon field="nomeConta" /></th>
          <th pSortableColumn="tipoLancamento.nome">Tipo de Lançamento<p-sortIcon field="tipoLancamento.nome" /></th>
          @if (resultado.ehContaBanco) {
            <th pSortableColumn="conciliado">Conciliado<p-sortIcon field="conciliado" /></th>
          }
          @if (exibirColunasCategoria) {
            <th pSortableColumn="nomeCategoria">Categoria<p-sortIcon field="nomeCategoria" /></th>
          }
          @if (exibirColunasCategoria) {
            <th pSortableColumn="observacaoCategoria">Obs. Categoria<p-sortIcon field="observacaoCategoria" /></th>
          }
          <th pSortableColumn="nomeLoteLancamentos">Lote<p-sortIcon field="nomeLoteLancamentos" /></th>
          <th pSortableColumn="observacao">Observação<p-sortIcon field="observacao" /></th>
          <th style="width: 130px;"></th>
        </tr>
      </ng-template>

      <ng-template #body let-lancamento let-editing="editing" let-rowIndex="rowIndex">
        <tr [pEditableRow]="lancamento" [pSelectableRow]="lancamento" [pSelectableRowIndex]="rowIndex"
          [pSelectableRowDisabled]="!modoSelecao || lancamento.conciliado">
          @if (modoSelecao) {
            <td class="col-checkbox">
              <p-tableCheckbox [value]="lancamento" [disabled]="lancamento.conciliado"></p-tableCheckbox>
            </td>
          }
          <td>{{ lancamento.data | date:'dd/MM/yyyy' }}</td>

          <td>
            <p-cellEditor>
              <ng-template #input>
                <p-inputnumber type="text" mode="currency" currency="BRL" [(ngModel)]="lancamento.valor" />
              </ng-template>
              <ng-template #output>
                <span [ngClass]="{'green-text': lancamento.valor >= 0, 'red-text': lancamento.valor < 0}">
                  {{ lancamento.valor | currency:'BRL' }}
                </span>
              </ng-template>
            </p-cellEditor>
          </td>

          <td>{{ lancamento.nomeConta }}</td>

          <td>
            <p-cellEditor>
              <ng-template #input>
                <app-generic-autocomplete [items]="tiposLancamento" displayField="nome" label="Tipo de lançamento"
                  inputId="tipoLancamento-{{ lancamento.id }}" [(ngModel)]="lancamento.tipoLancamento">
                </app-generic-autocomplete>
              </ng-template>
              <ng-template #output>
                {{ lancamento.tipoLancamento.nome }}
              </ng-template>
            </p-cellEditor>
          </td>

          @if (resultado.ehContaBanco) {
            <td>
              <div class="inline-element">
                <mat-checkbox [checked]="lancamento.conciliado" [disabled]="true"></mat-checkbox>
                <button mat-icon-button matTooltip="Visualizar correspondência" class="visibility-icon"
                  [disabled]="!lancamento.conciliado" (click)="visualizarCorrespondencia(lancamento)">
                  <mat-icon>visibility</mat-icon>
                </button>
              </div>
            </td>
          }

          @if (exibirColunasCategoria) {
            <td>{{ lancamento.nomeCategoria || '-' }}</td>
          }
          @if (exibirColunasCategoria) {
            <td>{{ lancamento.observacaoCategoria || '-' }}</td>
          }
          <td>
            <div class="inline-element lote-cell">
              <span class="lote-nome">{{ lancamento.nomeLoteLancamentos }}</span>
              <button mat-icon-button matTooltip="Visualizar lote" class="visibility-icon"
                (click)="visualizarLote(lancamento)">
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
          </td>

          <td>
            <p-cellEditor>
              <ng-template #input>
                <input pInputText type="text" [(ngModel)]="lancamento.observacao" />
              </ng-template>
              <ng-template #output>
                {{ lancamento.observacao || '-' }}
              </ng-template>
            </p-cellEditor>
          </td>

          <td>
            @if (!editing) {
              <div class="inline-element items-center">
                <button pButton pRipple type="button" pInitEditableRow matTooltip="Editar" icon="pi pi-pencil"
                  [disabled]="lancamento.conciliado || modoSelecao" [disableNoPermission]="permissaoEditarLancamento"
                (click)="onRowEditInit(lancamento)" text rounded severity="secondary"></button>
              </div>
            }
            @if (editing) {
              <div class="inline-element items-center">
                <button pButton pRipple type="button" matTooltip="Salvar" pSaveEditableRow icon="pi pi-check"
                (click)="onRowEditSave(lancamento)" text rounded severity="secondary"></button>
                <button pButton pRipple type="button" matTooltip="Cancelar" pCancelEditableRow icon="pi pi-times"
                (click)="onRowEditCancel(lancamento)" text rounded severity="secondary"></button>
              </div>
            }
          </td>

        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="quantidadeColunas" class="empty-message">
            Nenhum lançamento encontrado para os filtros selecionados.
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
